export default "__VITE_ASSET__173ecf7b__"